import { Link } from 'react-router-dom';

function FooterLink({ label, path }: { label: string; path: string }) {
  const isExternal = path.startsWith('mailto:') || path.startsWith('http');
  const className = 'font-sans text-sm text-cream hover:text-white transition-colors duration-300';

  if (isExternal) {
    return (
      <a href={path} className={className}>
        {label}
      </a>
    );
  }

  return (
    <Link to={path} className={className}>
      {label}
    </Link>
  );
}

export default function Footer() {
  const explorarLinks = [
    { label: 'Inicio', path: '/' },
    { label: 'Nuestros Programas', path: '/programas' },
    { label: 'Dormí Tranquila — 10 Capítulos', path: '/coleccion-completa-dormir-tranquila' },
    { label: 'Biblioteca Musical', path: '/coleccion-completa-musica' },
    { label: 'Best Sellers', path: '/coleccion-best-sellers' },
    { label: 'Más allá de la maternidad', path: '/#mas-alla-maternidad' },
    { label: 'Contenido Gratis', path: '/quiero-cambiar' },
    { label: 'Test del Sueño', path: '/test-sueno' },
  ];

  const socialLinks = [
    { label: 'Instagram', path: 'https://www.instagram.com/neurobabys.arg/', icon: 'ri-instagram-line' },
    { label: 'Facebook', path: 'https://www.facebook.com/profile.php?id=61593229844337', icon: 'ri-facebook-line' },
    { label: 'YouTube', path: 'https://www.youtube.com/@NeuroBabys', icon: 'ri-youtube-line' },
    { label: 'TikTok', path: 'https://www.tiktok.com/@neurobabys', icon: 'ri-tiktok-line' },
    { label: 'Pinterest', path: 'https://ar.pinterest.com/NeuroBabys/', icon: 'ri-pinterest-line' },
  ];

  const conocerLinks = [
    { label: 'Conocé a Mercedes', path: '/#bienvenida' },
    { label: 'El legado de Luisa Victoria', path: '/conoce-a-mercedes' },
    { label: 'Preguntas Frecuentes', path: '/' },
    { label: 'Contacto', path: 'mailto:neurobabys.arg@gmail.com' },
  ];

  return (
    <footer className="bg-dark-brown rounded-t-3xl mt-0">
      <div className="px-6 md:px-10 py-12 md:py-16">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-10 md:gap-8">
          {/* Columna 1 — Logo y tagline */}
          <div className="md:col-span-1">
            <Link to="/" className="font-serif text-3xl font-semibold text-white">
              NeuroBabys
            </Link>
            <p className="font-sans text-sm text-cream mt-4 leading-relaxed">
              Neurociencia, yoga y acompañamiento para el sueño de tu bebé, mes a mes.
            </p>
          </div>

          {/* Columna 2 — EXPLORAR */}
          <div>
            <h4 className="font-sans text-sm font-semibold text-white uppercase tracking-wider mb-4">
              Explorar
            </h4>
            <ul className="flex flex-col gap-3">
              {explorarLinks.map((link) => (
                <li key={link.label}>
                  <FooterLink label={link.label} path={link.path} />
                </li>
              ))}
            </ul>
          </div>

          {/* Columna 3 — CONOCER */}
          <div>
            <h4 className="font-sans text-sm font-semibold text-white uppercase tracking-wider mb-4">
              Conocer
            </h4>
            <ul className="flex flex-col gap-3">
              {conocerLinks.map((link) => (
                <li key={link.label}>
                  <FooterLink label={link.label} path={link.path} />
                </li>
              ))}
            </ul>
          </div>

          {/* Columna 4 — SÍGUENOS */}
          <div>
            <h4 className="font-sans text-sm font-semibold text-white uppercase tracking-wider mb-4">
              Síguenos
            </h4>
            <div className="flex flex-wrap items-center gap-3">
              {socialLinks.map((social) => (
                <a
                  key={social.label}
                  href={social.path}
                  target="_blank"
                  rel="noopener noreferrer"
                  aria-label={social.label}
                  title={social.label}
                  className="w-9 h-9 flex items-center justify-center rounded-full bg-white/10 text-white hover:bg-white/20 transition-colors cursor-pointer"
                >
                  <i className={`${social.icon} text-lg`} />
                </a>
              ))}
            </div>
            <p className="font-sans text-sm text-cream mt-6">
              neurobabys.arg@gmail.com
            </p>
          </div>
        </div>

        <div className="mt-12 pt-8 border-t border-white/10">
          <p className="font-sans text-xs text-cream text-center">
            © 2026 NeuroBabys. Todos los derechos reservados.
          </p>
        </div>
      </div>
    </footer>
  );
}